module.exports = __webpack_public_path__ + "static/media/collections.0652c9e5.png";